import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// import router from '@/router'

Vue.use(Vuex)

// const mainurl = 'http://192.168.1.105:8000';
const mainurl = 'https://appapi.akambc.com';

let state = {
    orders: [],
    systems: [],
    operators: [],
    glass: [],
    frame: [],
    category: [],
}
const mutations = {
    nothing(){},

    systems_list(state, systems){
        Vue.set(state, 'systems', systems);
        Vue.set(state, 'systems', [...systems]);
    },
    operators_list(state, operators){
        Vue.set(state, 'operators', operators);
        Vue.set(state, 'operators', [...operators]);
    },
    glass_list(state, glass){
        Vue.set(state, 'glass', glass);
        Vue.set(state, 'glass', [...glass]);
    },
    frame_list(state, frame){
        Vue.set(state, 'frame', frame);
        Vue.set(state, 'frame', [...frame]);
    },
    category(state, category){
        Vue.set(state, 'category', category);
        Vue.set(state, 'category', [...category]);
    },

    order_list(state , orders){
        Vue.set(state, 'orders', orders);
        Vue.set(state, 'orders', [...orders]);
    },

    add_order(state, order){
        state.orders.unshift(order)
    },

    edit_order(state, payload){
        const item = state.orders.find(item => item.id === payload.id);
        Object.assign(item, payload);
    },

    delete_order(state, id){
        const itemIndex = state.orders.findIndex(item => item.id === id);
        state.orders.splice(itemIndex , 1);
    },

}
const actions = {
    getSystemInfo({ commit, dispatch }){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/systems`, method: 'GET' })
            .then(res => {
                commit("systems_list" , res.data.systems)
                commit("operators_list" , res.data.operators)
                commit("glass_list" , res.data.glass)
                commit("frame_list" , res.data.frame)
                commit("category" , res.data.category)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                  }
                reject(err)
            })
        })
    },

    getOrders({ dispatch, commit }, payload){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/orders/${payload.type}?page=${payload.page}`, method: 'GET' })
            .then(res => {
                commit('order_list', res.data.data.data)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                  }
                reject(err)
            })
        })
    },

    getOrderInfo({ dispatch, commit }, id){
        commit('nothing')
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/order/${id}`, method: 'GET' })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    addOrder({ dispatch, commit }, payload){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/newOrder`, data: payload, method: 'POST' })
            .then(res => {
                commit('add_order', res.data.data[0])
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    updateOrderInfo({ dispatch, commit }, payload){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/editOrder`, data: payload, method: 'POST' })
            .then(res => {
                commit('edit_order', res.data.data[0])
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    deleteOrder({ dispatch, commit }, id){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/deleteOrder/${id}`, method: 'DELETE' })
            .then(res => {
                commit('delete_order' , id)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    }
}
const modules = {

}
const getters = {
}
export default({
    state,
    mutations,
    actions,
    getters,
    modules,
    axios
})
